import React from 'react';
import { Routes, Route } from 'react-router-dom';
// layouts
import Layout from './layouts/dashboard';
// pages
import User from './pages/User';
import Login from './pages/Login';
import NotFound from './pages/Page404';
import DashboardApp from './pages/DashboardApp';
import Protected from './Protected';
import Admin from './pages/Admin';
import CreateRegisterUser from './pages/CreateRegisterUser';
import CreateAdmin from './pages/CreateAdmin';
import AdminInfo from './pages/AdminInfo';
import EditInfo from './pages/EditInfo';
import UserInfo from './pages/UserInfo';
import RegisterUserInfo from './pages/RegisterUserInfo';
import RegisterUser from './pages/RegisterUser';
import MessageHistory from './pages/MessageHistory';
import PushNotification from './pages/PushNotification';
import ServerProfile from './pages/ServerProfile';
import SendPushNotification from './pages/SendPushNotification';
import PushNotificationInfo from './pages/PushNotificationInfo';
import OrgContact from './pages/OrgContact';

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="login" element={<Login />} />
      <Route element={<Protected />}>
        <Route element={<Layout />}>
          <Route path="dashboard" element={<DashboardApp />} />
          <Route path="profile" element={<ServerProfile />} />
          <Route path="admin">
            <Route index element={<Admin />} />
            <Route path="newadmin" element={<CreateAdmin />} />
            <Route path="contact" element={<OrgContact />} />
            <Route path="info">
              <Route path=":adminId" element={<AdminInfo />} />
              <Route path="edit">
                <Route path=":adminId" element={<EditInfo title="Edit Admin info" identity={'admin'} />} />
              </Route>
            </Route>
          </Route>
          <Route path="user">
            <Route path="history" element={<MessageHistory />} />
            <Route index element={<User />} />
            <Route path="info">
              <Route path=":id" element={<UserInfo />} />
              <Route path="edit">
                <Route path=":id" element={<EditInfo title="Edit User info" identity={'user'} />} />
              </Route>
            </Route>
          </Route>
          <Route path="register">
            <Route index element={<RegisterUser />} />
            <Route path="newuser" element={<CreateRegisterUser />} />
            <Route path="info">
              <Route path=":registerUserId" element={<RegisterUserInfo />} />
              <Route path="edit">
                <Route path=":registerUserId" element={<EditInfo title="Edit User info" identity={'registerUser'} />} />
              </Route>
            </Route>
          </Route>
          <Route path="push-notification">
            <Route index element={<PushNotification />} />
            <Route path="info">
              <Route path=":pushNotificationId" element={<PushNotificationInfo />} />
            </Route>
            <Route path="send-notification" element={<SendPushNotification />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
